import { render, staticRenderFns } from "./userPowerConf.vue?vue&type=template&id=0b0e4bf7&scoped=true&"
import script from "./userPowerConf.vue?vue&type=script&lang=js&"
export * from "./userPowerConf.vue?vue&type=script&lang=js&"
import style0 from "./userPowerConf.vue?vue&type=style&index=0&id=0b0e4bf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0e4bf7",
  null
  
)

component.options.__file = "userPowerConf.vue"
export default component.exports